import type { Position, Alignment } from "@fluentui/react-positioning";

export type DirectionalHintValue = {
  position: Position;
  align: Alignment;
};

export type DirectionalHintMap = {
  [key: number]: DirectionalHintValue;
};

export const DirectionalHint: DirectionalHintMap = {
  0: { position: "above", align: "center" },
  1: { position: "above", align: "center" },
  2: { position: "below", align: "center" },
  3: { position: "above", align: "start" },
  4: { position: "below", align: "center" },
  5: { position: "below", align: "end" },
  6: { position: "below", align: "end" },
  7: { position: "below", align: "end" },
  8: { position: "before", align: "end" },
  9: { position: "before", align: "end" },
  10: { position: "before", align: "end" },
  11: { position: "after", align: "end" },
  12: { position: "after", align: "end" },
  13: { position: "after", align: "end" },
};
